import { render, staticRenderFns } from "./matcher.vue?vue&type=template&id=5bdb1dd3"
import script from "./matcher.vue?vue&type=script&lang=js"
export * from "./matcher.vue?vue&type=script&lang=js"
import style0 from "./matcher.vue?vue&type=style&index=0&id=5bdb1dd3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports